module.exports = __webpack_public_path__ + "img/partner_logo06.9818e5dd.png";